'use client';
var classes = {"root":"m-de3d2490","colorOverlay":"m-862f3d1b","shadowOverlay":"m-98ae7f22","alphaOverlay":"m-95709ac0","childrenOverlay":"m-93e74e3"};

export { classes as default };
//# sourceMappingURL=ColorSwatch.module.css.mjs.map
